import { DEFAULT_FILTERS } from '../../config';
import { applyCssFiltersToImageData } from './filterPipeline';

export const hasActiveFilters = (filters) => {
  const f = filters || DEFAULT_FILTERS;
  return (
    (f.blur || 0) !== 0 ||
    (f.brightness || 0) !== 0 ||
    (f.contrast || 0) !== 0 ||
    (f.saturation || 0) !== 0 ||
    (f.temperature || 0) !== 0
  );
};

export function CssImageFilter(imageData) {
  const filters = this?.attrs?.msFilters || DEFAULT_FILTERS;
  applyCssFiltersToImageData(imageData, filters);
}
